import React,{useState,useEffect} from 'react';
import MultiSelect from './MultiSelect';

const  NotificationFilter = (props) => {
const[multiValue,setMutiValue]=useState([]);
const[providersForFilter,setProvidersForFilter]=useState([]);
const handleNotificationFilterChange = (selectedValue) => {
setMutiValue(selectedValue);
props.filterAssignee(selectedValue, "status");
};
        useEffect(() => {
                const notificationOptions = [];
                let uniqueArray = [];
                if (props.patientList) {
                        uniqueArray = [...new Map(props.patientList.map(item => [item.Assignee.jiraAssignee[item.Assignee.jiraAssignee.length-1], item])).values()];
                        uniqueArray.map((obj) => {
                                return notificationOptions.push({
                                        value: obj.id,
                                        label: obj.Assignee.jiraAssignee[obj.Assignee.jiraAssignee.length-1]
                                });
                        });
                }
                setProvidersForFilter(notificationOptions);
        }, [props]);
        useEffect(() => {
                setMutiValue([]);
        }, [props.patientList]);
        return(
                <>
                <MultiSelect
                options={providersForFilter}
                name={"Assigned To"}
                isMulti
                checkBoxStyled
                onChange={handleNotificationFilterChange}
                value={multiValue}
                isSearchable = {false}
                isClearable = {false}
                placeholder = {multiValue&&multiValue.length>0?"Assigned To ":"Assigned To : All"}
                textFieldProps={{
                variant:"outlined",
                label:''
                }}
                >
                </MultiSelect>
                </>
            );
        };
export default (NotificationFilter);